import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconFigma = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 25" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.25 6.0743C4.25 3.81914 6.07817 1.99097 8.33333 1.99097H12.4167V10.1576H8.33333C6.07817 10.1576 4.25 8.32946 4.25 6.0743ZM8.33333 3.49097C6.9066 3.49097 5.75 4.64756 5.75 6.0743C5.75 7.50104 6.9066 8.65763 8.33333 8.65763H10.9167V3.49097H8.33333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0833 6.0743C19.0833 3.81914 17.2551 1.99097 15 1.99097H10.9166V10.1576H15C17.2551 10.1576 19.0833 8.32946 19.0833 6.0743ZM15 3.49097C16.4267 3.49097 17.5833 4.64756 17.5833 6.0743C17.5833 7.50104 16.4267 8.65763 15 8.65763H12.4166V3.49097H15Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0833 12.7408C19.0833 10.4856 17.2551 8.65747 15 8.65747C12.7448 8.65747 10.9166 10.4856 10.9166 12.7408C10.9166 14.996 12.7448 16.8241 15 16.8241C17.2551 16.8241 19.0833 14.996 19.0833 12.7408ZM15 10.1575C16.4267 10.1575 17.5833 11.3141 17.5833 12.7408C17.5833 14.1675 16.4267 15.3241 15 15.3241C13.5732 15.3241 12.4166 14.1675 12.4166 12.7408C12.4166 11.3141 13.5732 10.1575 15 10.1575Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.25 12.7408C4.25 10.4856 6.07817 8.65747 8.33333 8.65747H12.4167V16.8241H8.33333C6.07817 16.8241 4.25 14.996 4.25 12.7408ZM8.33333 10.1575C6.9066 10.1575 5.75 11.3141 5.75 12.7408C5.75 14.1675 6.9066 15.3241 8.33333 15.3241H10.9167V10.1575H8.33333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.25 19.4078C4.25 17.1526 6.07817 15.3245 8.33333 15.3245H12.4167V19.4078C12.4167 21.663 10.5885 23.4911 8.33333 23.4911C6.07817 23.4911 4.25 21.663 4.25 19.4078ZM8.33333 16.8245C6.9066 16.8245 5.75 17.9811 5.75 19.4078C5.75 20.8345 6.9066 21.9911 8.33333 21.9911C9.76007 21.9911 10.9167 20.8345 10.9167 19.4078V16.8245H8.33333Z"
      fill="currentColor"
    />
  </SvgIcon>
)
